var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: { title: _vm.title, visible: _vm.visible },
      on: { cancel: _vm.closeModal },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function() {
            return [
              _c(
                "a-space",
                [
                  _c("a-button", { on: { click: _vm.closeModal } }, [
                    _vm._v(" " + _vm._s(_vm.$t("lbl_close")) + " ")
                  ]),
                  _vm.$can("update", "branch-warehouse")
                    ? _c(
                        "a-button",
                        {
                          attrs: { type: "primary", loading: _vm.loading },
                          on: { click: _vm.validateForm }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("lbl_save")) + " ")]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "a-form-model",
        {
          ref: "formModel",
          attrs: {
            rules: _vm.formRules,
            model: _vm.form,
            "wrapper-col": { span: 18 },
            "label-col": { span: 6 },
            "label-align": "left"
          }
        },
        [
          _c(
            "a-form-model-item",
            { attrs: { label: _vm.$t("lbl_branch"), prop: "branchName" } },
            [
              _c("SelectBranch", {
                on: { "update:meta": _vm.onChangeBranch },
                model: {
                  value: _vm.form.branchName,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "branchName", $$v)
                  },
                  expression: "form.branchName"
                }
              })
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { label: _vm.$t("lbl_name"), prop: "name" } },
            [
              _c("a-input", {
                attrs: { "allow-clear": "" },
                model: {
                  value: _vm.form.name,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name"
                }
              })
            ],
            1
          ),
          _c(
            "a-form-model-item",
            {
              attrs: { label: _vm.$t("lbl_address"), prop: "address" },
              scopedSlots: _vm._u([
                {
                  key: "extra",
                  fn: function() {
                    return [
                      _c("character-length", {
                        attrs: { value: _vm.form.address }
                      })
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _c("a-textarea", {
                attrs: { "allow-clear": "" },
                model: {
                  value: _vm.form.address,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "address", $$v)
                  },
                  expression: "form.address"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }